import { DebitNoteRepository } from "../repositories/DebitNoteRepository";
import {
  DebitNoteOperationResult,
  DebitNoteDataEntity,
} from "../entities/DebitNoteEntity";

/**
 * Update Debit Note JSON Use Case
 * Updates debit note JSON data (for auto-save and manual edits)
 */
export class UpdateDebitNoteJsonUseCase {
  constructor(private repository: DebitNoteRepository) {}

  async execute(
    debitNoteId: number,
    debitNoteData: DebitNoteDataEntity
  ): Promise<DebitNoteOperationResult> {
    return await this.repository.updateDebitNoteJson(
      debitNoteId,
      debitNoteData
    );
  }
}

